import React, { useState } from "react";
import { submitLeadQuietly } from "../lib/crm";
import { motion } from "framer-motion";


const countries = [
  "India",
  "United States",
  "United Kingdom",
  "United Arab Emirates",
  "Singapore",
  "Germany",
  "Canada",
  "Australia",
  "Other",
];

// Identifies this form to the CRM: becomes the campaign name and the key its
// Lead Routing rule matches on.
const CRM_FORM_ID = "sas-webinar";

export default function Sas_web() {
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    org: "",
    jobTitle: "",
    country: countries[0],
    phone: "",
    consent: true,
  });
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [gotcha, setGotcha] = useState(""); // bot trap; kept out of the Sheet payload

  const onChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((f) => ({ ...f, [name]: type === "checkbox" ? checked : value }));
  };

  const validate = () => {
    const e = {};
    if (!form.firstName.trim()) e.firstName = "First name is required";
    if (!form.lastName.trim()) e.lastName = "Last name is required";
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i.test(form.email)) e.email = "Valid email required";
    if (!form.org.trim()) e.org = "Organization / Institute is required";
    if (!form.jobTitle.trim()) e.jobTitle = "Job title is required";
    if (!/^\+?[0-9\-()\s]{7,}$/.test(form.phone)) e.phone = "Valid phone required";
    if (!form.consent) e.consent = "You must accept the privacy policy";
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const onSubmit = async (e) => {
  e.preventDefault();

  try {
    // Double-writing while the CRM proves itself: the Sheet is still the
    // source of truth, so only its outcome decides what the visitor sees.
    const [sheetResult] = await Promise.allSettled([
      fetch("https://script.google.com/macros/s/AKfycbxrL5Xd83TvTP30RnE1S8-XZt4_33sCtTBoFvx9mgoogR2qlVy0NFRKQMKwIUren_kA/exec", {
        method: "POST",
        mode: "no-cors", // required since GAS by default doesn't handle CORS
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      }),
      submitLeadQuietly({
        formId: CRM_FORM_ID,
        // The CRM has one name column, so join the two halves for it.
        fields: { fullName: `${form.firstName} ${form.lastName}`.trim(), ...form, _gotcha: gotcha },
      }),
    ]);
    if (sheetResult.status === "rejected") throw sheetResult.reason;
 
    // Assume success since we can't read response with no-cors
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 6000);

    // Reset form after success
    setForm({
      firstName: "",
      lastName: "",
      email: "",
      org: "",
      jobTitle: "",
      country: countries[0], // default back to first country
      phone: "",
      consent: true,
    });

    // Auto-hide success message after 4 seconds
    
  } catch (err) {
    console.error("Network error:", err);
  }
};



  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-sky-50 text-slate-800">
      {/* Top bar */}
      <header className="sticky top-0 z-20 bg-white/80 backdrop-blur border-b border-slate-100">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
          <div className="flex items-center gap-3">
  <img
    src="/UniThink x SAS logo.png"   // <-- put your logo path here
    alt="SAS Logo"
    className="h-16 w-auto"
  />
  
</div>

          <nav className="hidden md:flex items-center gap-6 text-sm">
            <a href="#about" className="hover:text-sky-700">About</a>
            <a href="#agenda" className="hover:text-sky-700">Agenda</a>
            <a href="#experts" className="hover:text-sky-700">Experts</a>
            <a href="#register" className="inline-flex items-center rounded-full border border-sky-600 px-4 py-1.5 text-sky-700 hover:bg-sky-50">Register</a>
          </nav>
        </div>
      </header>

      {/* Hero */}
      <section className="mx-auto max-w-screen-xl px-4 sm:px-6 lg:px-8 pt-10 pb-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-start">
          <div>
            <motion.p initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}
              className="text-xs font-semibold tracking-widest uppercase text-sky-700">Live Webinar</motion.p>
            <motion.h1 initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.55 }}
              className="mt-2 text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight text-slate-900">
              Kickstart Your Career in Data & AI with SAS
            </motion.h1>
            <p className="mt-3 text-slate-600 max-w-2xl">
              Join this complimentary Webinar for valuable insights into building a career in the GenAI era.
            </p>
            <div className="mt-5 flex flex-wrap gap-3 text-sm text-slate-700">
              <span className="inline-flex items-center rounded-full bg-sky-50 px-3 py-1 ring-1 ring-sky-200">Wed, 17 Sept 2025</span>
              <span className="inline-flex items-center rounded-full bg-sky-50 px-3 py-1 ring-1 ring-sky-200">11:00 AM – 12:00 PM IST</span>
              <span className="inline-flex items-center rounded-full bg-emerald-50 px-3 py-1 ring-1 ring-emerald-200">Cost: Complimentary</span>
            </div>
          </div>

          {/* Form card */}
          <motion.div id="register" initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.45 }}
            className="lg:justify-self-end w-full">
            <div className="rounded-2xl border border-slate-200 bg-white shadow-sm p-4 sm:p-6">
              <div className="mb-4 flex items-center justify-between">
                <h2 className="text-lg font-semibold">Register for the webinar</h2>
                
              </div>
              <form onSubmit={onSubmit} noValidate className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {/* Bot trap: hidden from people, so anything typed here is spam. */}
                <input
                  type="text"
                  name="_gotcha"
                  value={gotcha}
                  onChange={(e) => setGotcha(e.target.value)}
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  style={{ position: "absolute", left: "-9999px", width: 1, height: 1, opacity: 0 }}
                />
                <Field label="First Name" name="firstName" value={form.firstName} onChange={onChange} error={errors.firstName} required />
                <Field label="Last Name" name="lastName" value={form.lastName} onChange={onChange} error={errors.lastName} required />
                <Field label="Email" type="email" name="email" value={form.email} onChange={onChange} error={errors.email} required className="sm:col-span-2" />
                <Field label="Organization / Institute" name="org" value={form.org} onChange={onChange} error={errors.org} required className="sm:col-span-2" />
                <Field label="Job Title" name="jobTitle" value={form.jobTitle} onChange={onChange} error={errors.jobTitle} required className="sm:col-span-2" />
                <div className="sm:col-span-1">
                  <label className="block text-sm font-medium text-slate-700">Country / Region</label>
                  <select name="country" value={form.country} onChange={onChange} className="mt-1 w-full rounded-xl border-slate-300 focus:border-sky-500 focus:ring-sky-500">
                    {countries.map((c) => (
                      <option key={c} value={c}>{c}</option>
                    ))}
                  </select>
                </div>
                <Field label="Mobile Phone" name="phone" value={form.phone} onChange={onChange} error={errors.phone} placeholder="e.g., +91 98765 43210" />

                <div className="sm:col-span-2 flex items-start gap-3">
                  <input id="consent" name="consent" checked={form.consent} onChange={onChange} type="checkbox" className="mt-1 h-4 w-4 rounded border-slate-300 text-sky-600 focus:ring-sky-500" />
                  <label htmlFor="consent" className="text-sm text-slate-600">
                    Yes, I would like to receive occasional emails from SAS Institute Inc. and its affiliates about SAS products and services. I understand that I can withdraw my consent at any time by clicking the opt-out link in the emails.
                  </label>
                </div>
                {errors.consent && <p className="sm:col-span-2 text-sm text-rose-600">{errors.consent}</p>}

                <div className="sm:col-span-2 flex items-center gap-3">
                  <button
  type="submit"
  disabled={submitted}
  className={`inline-flex justify-center rounded-xl px-5 py-2.5 font-medium focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 ${
    submitted
      ? "bg-emerald-600 text-white"
      : "bg-sky-700 text-white hover:bg-sky-800 focus-visible:ring-sky-600"
  }`}
>
  {submitted ? "Registration Successful" : "Register Now"}
</button>

               </div>
                <p className="sm:col-span-2 text-xs text-slate-500">All personal information will be handled in accordance with the SAS Privacy Statement.</p>
              </form>
            </div>
          </motion.div>
        </div>
      </section>

      {/* About & Agenda */}
      <section id="about" className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 pb-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14">
          <div>
            <h3 className="text-xl font-semibold">About the webinar</h3>
            <p className="mt-3 text-slate-700 leading-relaxed">
              Data and AI are reshaping every industry, from banking to healthcare. But with so many learning paths, how do you start and grow in the GenAI era?
              <br /><br />
              This webinar introduces the <span className="font-medium">SAS Academy for Data & AI Excellence</span>, a structured program designed to build your expertise in Data Engineering, Business Analytics, and AI-ML.
              <br /><br />
              Learn how global certifications, hands-on labs, and industry-recognized skills can fast-track your career.
            </p>
          </div>
          <div id="agenda">
            <h3 className="text-xl font-semibold">Agenda</h3>
            <ul className="mt-3 space-y-3 text-slate-700">
              <li className="flex gap-3"><span className="mt-1 h-2 w-2 rounded-full bg-sky-600"></span>Why Data & AI careers are in demand</li>
              <li className="flex gap-3"><span className="mt-1 h-2 w-2 rounded-full bg-sky-600"></span>How SAS Academy prepares you with global certifications and practical labs</li>
              <li className="flex gap-3"><span className="mt-1 h-2 w-2 rounded-full bg-sky-600"></span>Overview of four tracks: Foundation, Data Engineering, Business Analytics, AI-ML</li>
              <li className="flex gap-3"><span className="mt-1 h-2 w-2 rounded-full bg-sky-600"></span>Career outcomes and success stories</li>
              <li className="flex gap-3"><span className="mt-1 h-2 w-2 rounded-full bg-sky-600"></span>Live Q&A</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Experts */}
      <section id="experts" className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 pb-16">
        <h3 className="text-xl font-semibold">About the Experts</h3>
        <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="p-5 rounded-2xl border border-slate-200 bg-white shadow-sm">
            <h4 className="text-lg font-medium">John Coutinho</h4>
            <p className="text-sm text-slate-500">Principal Technical Training Consultant, SAS India</p>
            <p className="mt-2 text-slate-700 text-sm leading-relaxed">
              Presently a Senior Education Consultant with SAS India, he has over 20+ years of training and mentoring experience with leading clients in India and abroad. He has conducted workshops in data management, business analytics, reporting, and SAS Viya administration.
            </p>
          </div>
          <div className="p-5 rounded-2xl border border-slate-200 bg-white shadow-sm">
            <h4 className="text-lg font-medium">Ritu Sekhon</h4>
            <p className="text-sm text-slate-500">Analytical Training Consultant, SAS India</p>
            <p className="mt-2 text-slate-700 text-sm leading-relaxed">
              Presently working as an Analytics Training Consultant with SAS India. She has extensive training experience with government, banking, insurance, and academia clients in India, focusing on Predictive Modelling, Forecasting, Optimization, Visual Statistics, Data Visualization, Text Analytics, and Deep Learning.
            </p>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="border-t border-slate-200 py-8 text-sm">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-slate-600">©️ {new Date().getFullYear()} UniThink • Education Consulting & Services</p>
          <div className="flex items-center gap-6">
            <a href="#" className="hover:text-sky-700">Privacy</a>
            <a href="#" className="hover:text-sky-700">Terms</a>
            <a href="#" className="hover:text-sky-700">Contact</a>
          </div>
        </div>
      </footer>
    </div>
  );
}

function Field({ label, name, value, onChange, error, className = "", type = "text", placeholder, required }) {
  return (
    <div className={className}>
      <label htmlFor={name} className="block text-sm font-medium text-slate-700">
        {label}{required && <span className="text-rose-600"> *</span>}
      </label>
      <input
        id={name}
        name={name}
        value={value}
        onChange={onChange}
        type={type}
        placeholder={placeholder}
        required={required}
        className={`mt-1 w-full rounded-xl border ${error ? "border-rose-400 focus:border-rose-500 focus:ring-rose-500" : "border-slate-300 focus:border-sky-500 focus:ring-sky-500"} px-3 py-2 outline-none`}
        aria-invalid={!!error}
        aria-describedby={error ? `${name}-error` : undefined}
      />
      {error && (
        <p id={`${name}-error`} className="mt-1 text-xs text-rose-600">{error}</p>
      )}
    </div>
  );
}
